import { FollowUpImportance } from '../../viewModels/queue';
import type { FocusedLead } from '../data';

/**
 * Follow-up dot color by importance — mirrors the legacy `CurrentFollowUp`
 * pepper (High = red, Medium = orange, Low = green).
 */
export const FOLLOW_UP_DOT: Record<FollowUpImportance, string> = {
	[FollowUpImportance.High]: '#E5484D',
	[FollowUpImportance.Medium]: '#F89143',
	[FollowUpImportance.Low]: '#89C947',
};

/**
 * Label for the follow-up badge in the lead metadata strip, e.g.
 * "Follow-up · 6/24/26, 2:00 PM". An unscheduled follow-up is marked as such,
 * and a missing/unparseable date degrades to the bare prefix.
 */
export function formatFollowUp(followUp: NonNullable<FocusedLead['followUp']>): string {
	const prefix = followUp.scheduled === false ? 'Unscheduled follow-up' : 'Follow-up';
	if (!followUp.date) return prefix;
	const date = new Date(followUp.date);
	if (Number.isNaN(date.getTime())) return prefix;
	const when = date.toLocaleString(undefined, {
		month: 'numeric',
		day: 'numeric',
		year: '2-digit',
		hour: 'numeric',
		minute: '2-digit',
	});
	return `${prefix} · ${when}`;
}
